(function () {
  var st = document.createElement('style');
  st.textContent = '.lg-menu-label{color:#D32F2F !important;font-weight:700;font-size:11px;margin-left:5px;white-space:nowrap;letter-spacing:.2px}a:has(.lg-menu-label){white-space:nowrap}';
  document.head.appendChild(st);
  function apply() {
    document.querySelectorAll('header a, nav a, .mobile-nav__link, .mega-menu a').forEach(function (a) {
      if (a.textContent.indexOf('[') === -1) return;
      var m = a.innerHTML.match(/\[([^\]]+)\]/);
      if (m) {
        a.innerHTML = a.innerHTML.replace(/\s*\[[^\]]+\]/, ' <span class="lg-menu-label">' + m[1] + '</span>');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();